import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Locale } from '@rd/types';
import * as CSS from 'csstype';
import { UrlUtilsService } from '../../services/url-utils/url-utils.service';

@Component({
  selector: 'rd-core-header-locale-select-mobile',
  templateUrl: './header-locale-select-mobile.component.html',
  styleUrls: ['./header-locale-select-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLocaleSelectMobileComponent {
  @HostBinding('class.rd-core-header-locale-select-mobile')
  componentClass = true;
  @Input() locales: Locale[];
  @Input() localeSelected: Locale;
  @Output() changeLocale: EventEmitter<Locale> = new EventEmitter<Locale>();

  @ViewChild('mobileLanguageSelect', { static: true })
  mobileLanguageSelect?: ElementRef;

  constructor(private urlUtilsService: UrlUtilsService) {}

  emitChangeLocaleEvent(locale: Locale): void {
    this.changeLocale.emit(locale);
    this.mobileLanguageSelect?.nativeElement.blur();
  }

  flagClass(): string {
    return `flag-${this.localeSelected?.code.toLowerCase()}`;
  }

  flagBackgroundImageStyle(): CSS.Properties {
    return {
      backgroundImage: `url(${this.urlUtilsService.imageUrl(
        '/images/flags/flags-25-standard.png',
      )})`,
    };
  }
}
